module.exports = __webpack_public_path__ + "jp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/jp.svg
// module id = 630
// module chunks = 0